import { inject } from '@angular/core';
import { HashMap, TranslocoService } from '@jsverse/transloco';
import { switchMap } from 'rxjs';
import { TranslatableString } from './TranslatableString';
import { TranslatableStringType } from './types';
import { translate } from './utils';

export class TranslatableService {
  protected scope: string;
  protected translationService: TranslocoService;
  private translationsInitialized = false;

  constructor(serviceName: string) {
    this.scope = serviceName.charAt(0).toLowerCase() + serviceName.slice(1);
    this.translationService = inject(TranslocoService);

    // Note! This service should be used from bl.service.ts or any other service that extends it
    // and is provided in the root, because of this unclosed subscription.
    this.translationService.langChanges$
      .pipe(switchMap(() => this.translationService.selectTranslation(this.scope)))
      .subscribe(() => {
        this.translationsInitialized = true;
      });
  }

  getActiveLanguage = (): string => this.translationService.getActiveLang();

  translate = (
    key: string,
    options: {
      params?: HashMap;
      useComponentScope?: boolean;
    } = { useComponentScope: true },
  ): TranslatableStringType => {
    const { scope, translationService, translationsInitialized } = this;
    const translated = translate(key, { scope, translationService, translationsInitialized }, options);
    return new TranslatableString(translated) as TranslatableStringType;
  };

  get selectedTranslation$() {
    return this.translationService.selectTranslation(this.scope);
  }
}
